import { Box, IconButton } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { createSOSRequest } from "redux/actions/Master";
import { FETCH_ERROR } from "shared/constants/ActionTypes";

function Sos() {
    const dispatch = useDispatch();
    const getUserLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const payload = {
                        mapUrl: `http://maps.google.com/maps?z=12&t=m&q=loc:${latitude}+${longitude}`,
                        originDomain: window.location.hostname,
                    };
                    dispatch(createSOSRequest(payload));
                },
                (error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.code === 1
                                ? `${error.message} Kindly unblock location from location setting of browser/app.`
                                : error.message,
                    });
                    console.error("Error getting user location:", error);
                }
            );
        } else {
            dispatch({
                type: FETCH_ERROR,
                payload: "Geolocation is not supported by this browser.",
            });
            console.error("Geolocation is not supported by this browser.");
        }
    };
    return (
        <Box
            sx={{
                position: "fixed",
                right: 0,
                top: "50%",
                zIndex: 9999,
                background: "red",
                borderRadius: "10px 0 0 10px",
                "& img": {
                    width: 30,
                },
            }}
        >
            <IconButton onClick={() => getUserLocation()}>
                <img src={"/assets/images/dashboard/sos.svg"} alt="" />
            </IconButton>
        </Box>
    );
}

export default Sos;
